const isTrue = (value) => value === true || value === 'true';
const isFalse = (value) => value === false || value === 'false';

const roundTo = (value, precision = 2) => {
	if (!Number.isFinite(value)) {
		return NaN;
	}
	const factor = 10 ** precision;
	return Math.round(value * factor) / factor;
};

const parseCellValue = (cell) => {
	const input = cell.find('.answer-text');
	if (input.length === 0) {
		return 0;
	}
	const raw = input.val();
	if (raw === undefined || raw === null) {
		return 0;
	}
	const normalized = raw.toString().replace(/,/g, '').replace(/%/g, '').trim();
	if (normalized === '') {
		return 0;
	}
	const numeric = Number(normalized);
	return Number.isNaN(numeric) ? 0 : numeric;
};

const aggregateValues = (values, method) => {
	if (!values.length) {
		return null;
	}
	const total = values.reduce((sum, value) => sum + (Number.isFinite(value) ? value : 0), 0);
	if (method === 'average') {
		return values.length === 0 ? null : total / values.length;
	}
	return total;
};

const setCellValue = (cell, value, method) => {
	const input = cell.find('.answer-text');
	if (input.length === 0) {
		return;
	}

	if (value === null || value === undefined || Number.isNaN(value)) {
		if (input.val() !== '') {
			input.val('');
		}
		input.removeClass('filled');
		cell.removeClass('completed');
		return;
	}

	let output = value;
	if (method === 'average') {
		output = roundTo(value, 2);
	}

	const display = output.toString();
	if (input.val() !== display) {
		input.val(display);
	}
	input.addClass('filled');
	cell.addClass('completed');
};

const collectColumnIds = (cells) => {
	const ids = new Set();
	cells.each((_, el) => {
		const columnId = $(el).data('columnId');
		if (columnId !== undefined) {
			ids.add(columnId);
		}
	});
	return Array.from(ids);
};

const updateColumnTotals = (tableEl) => {
	const totalColumnCells = tableEl.find('tbody td.survey-table-cell[data-total-column="true"]');
	if (!totalColumnCells.length) {
		return;
	}

	const totalColumnIds = collectColumnIds(totalColumnCells);

	totalColumnIds.forEach((columnId) => {
		const methodSource = totalColumnCells.filter(`[data-column-id='${columnId}']`).first();
		const method = methodSource.data('columnTotalMethod') || 'sum';

		tableEl.find('tbody tr').each(function() {
			const row = $(this);
			const targetCell = row.find(`td.survey-table-cell[data-column-id='${columnId}']`);
			if (!targetCell.length) {
				return;
			}

			const sourceCells = row.find('td.survey-table-cell').filter(function() {
				const cell = $(this);
				const currentColumnId = cell.data('columnId');
				if (currentColumnId === columnId) {
					return false;
				}
				const includeFlag = cell.data('columnIncludeInTotal');
				return !isFalse(includeFlag);
			});

			if (!sourceCells.length) {
				setCellValue(targetCell, null, method);
				return;
			}

			const values = sourceCells.map((_, el) => parseCellValue($(el))).get();
			const totalValue = aggregateValues(values, method);
			setCellValue(targetCell, totalValue, method);
		});
	});
};

const updateRowTotals = (tableEl) => {
	const totalRows = tableEl.find('tbody tr[data-total-row="true"]');
	if (!totalRows.length) {
		return;
	}

	const columnIds = collectColumnIds(tableEl.find('tbody td.survey-table-cell'));

	totalRows.each(function() {
		const totalRow = $(this);
		const method = totalRow.data('totalMethod') || 'sum';

		columnIds.forEach((columnId) => {
			const targetCell = totalRow.find(`td.survey-table-cell[data-column-id='${columnId}']`);
			if (!targetCell.length) {
				return;
			}

			const values = [];
			tableEl.find('tbody tr').each(function() {
				const row = $(this);
				if (row.is(totalRow) || isTrue(row.data('totalRow'))) {
					return;
				}
				if (isFalse(row.data('includeInTotal'))) {
					return;
				}
				const cell = row.find(`td.survey-table-cell[data-column-id='${columnId}']`);
				if (!cell.length) {
					return;
				}
				values.push(parseCellValue(cell));
			});

			const totalValue = aggregateValues(values, method);
			setCellValue(targetCell, totalValue, method);
		});
	});
};

const UpdateTotals = (targetEl) => {
	
  if (!targetEl || targetEl.length === 0) {
		return;
	}

	const cell = targetEl.hasClass('survey-table-cell') ? targetEl : targetEl.closest('.survey-table-cell');
	if (!cell.length) {
		return;
	}

	const table = cell.closest('table');
	if (!table.length) {
		return;
	}

	if (!table.data('hasTotals') == 'true') {
		return;
	}

	updateColumnTotals(table);
	updateRowTotals(table);
};

export default UpdateTotals;
